export const OBTENER_UBICACIONES = 'ubicaciones_traer_todas';
export const ERROR = 'ubicaciones_error';
export const LOADING = 'ubicaciones_loading';